import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import  { ArrowLeftOutlined } from '@ant-design/icons';
import { UserService } from '../../services/user.api.client';
import { useCompany } from '../../contexts/CompanyContext';
import { useConfig } from '../../contexts/ConfigContext';
import { useUser } from '../../contexts/UserContext';
import { Permissions } from '../../models/calendar/Permissions.model';

interface UserConfigBoardProps {
   id:string;
   back:(exit:boolean)=>void;
}

type Permission = {
  key: string;
  label: string;
  type: "view"|"action";
};

const permissionsList: Permission[] = [
  { key: "calendar.events.main.action.create_event", label: "Crear eventos", type: "action"},
  { key: "calendar.events.main.action.edit_event", label: "Editar eventos", type: "action" },
  { key: "calendar.events.main.action.delete_event", label: "Eliminar eventos", type: "action"  },
];

const UserConfigBoardEvent: React.FC<UserConfigBoardProps> = ({id,back}) => {
    const [selected, setSelected] = useState<string[]>([]);
    const {company} = useCompany();
    const {user,updateUser} = useUser();
    const {config} = useConfig();


    useEffect(()=>{
        if (!company.current.uid) return;
        UserService.getPermissions(company.current.uid,id).then((response)=>{
            const permissions: Permissions = response;
            setSelected(permissions.actions);
        })
    },[company.current.uid, id])

    const togglePermission = (key: string) => {
        setSelected((prev) =>
        prev.includes(key) ? prev.filter((perm) => perm !== key) : [...prev, key]
        );
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const data = permissionsList.filter((record)=>selected.includes(record.key));
        const body:{views:string[],actions:string[]} = {
            views: data.filter((permission)=>permission.type=="view").map((record)=>record.key),
            actions: data.filter((permission)=>permission.type=="action").map((record)=>record.key)
        }
        UserService.updatePermissions(company.current.uid,id,config.key,body).then((response)=>{
            updateUser({permissions:{...body}})
        })
    };



    const handlerBack = ()=>{
        back(false);
    }

    return (
        <form
            onSubmit={handleSubmit}
            className="p-2 rounded-xl"
            >
            <Button onClick={handlerBack} color="default" variant="text" className='mb-2' iconPosition='start'>
                <ArrowLeftOutlined />
                Volver
            </Button>
            <h1 className="text-xl font-bold mb-4 text-gray-800">
                Gestión de Permisos de Usuario
            </h1>

            <fieldset className="border border-gray-300 rounded-lg p-4">
                <legend className="font-semibold text-gray-600">Permisos de Eventos</legend>

                {permissionsList.map(({ key, label }) => (
                <label key={key} className="block mt-2">
                    <input
                    type="checkbox"
                    value={key}
                    checked={selected.includes(key)}
                    onChange={() => togglePermission(key)}
                    className="mr-2"
                    />
                    {label}
                </label>
                ))}
            </fieldset>

            <div className="flex gap-2 mt-4">
                <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                Guardar cambios
                </button>
                <button
                type="button"
                onClick={() => setSelected([])}
                className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                >
                Restablecer
                </button>
            </div>
        </form>
    );
};

export default UserConfigBoardEvent;